/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Bulk_Run_MatchingInputs */

const cs_demands_bulk_run_matching = /** @type {(inputs: Demands_Bulk_Run_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit párování na vybraných`)
};

const en_demands_bulk_run_matching = /** @type {(inputs: Demands_Bulk_Run_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run matching on selected`)
};

/**
* | output |
* | --- |
* | "Run matching on selected" |
*
* @param {Demands_Bulk_Run_MatchingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_bulk_run_matching = /** @type {((inputs?: Demands_Bulk_Run_MatchingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Bulk_Run_MatchingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_bulk_run_matching(inputs)
	return cs_demands_bulk_run_matching(inputs)
});